<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    Invoice KAG
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-row class="justify-center py-5">
                    <v-col cols="8">
                        <v-text-field
                            v-model="searchInv"
                            append-icon="mdi-magnify"
                            dense
                            label="Search"
                            :rules="numberRule"
                            type="number"
                            @keydown="alert = false"
                            v-on:keyup.enter="searchInvoice"
                        ></v-text-field>

                        <v-alert :value="alert" type="warning">
                            {{ alertMsg }}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="8">
                        <v-card>
                            <v-toolbar color="primary" dense dark>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text">
                                    Create
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-container grid-list-xs>
                                <v-form ref="form" lazy-validation>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                label="Start Date"
                                                id="StartDate"
                                                :value="startDate"
                                                :placeholder="
                                                    $store.state.placeholder
                                                "
                                                v-mask="$store.state.mask"
                                                :rules="$store.state.dateRules"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-text-field
                                                label="End Date"
                                                id="EndDate"
                                                :value="endDate"
                                                :placeholder="
                                                    $store.state.placeholder
                                                "
                                                v-mask="$store.state.mask"
                                                :rules="$store.state.dateRules"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                label="Kms"
                                                v-model="Kms"
                                                :rules="[
                                                    v =>
                                                        !!v || 'Kms is required'
                                                ]"
                                                required
                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="6">
                                            <v-text-field
                                                label="FSC"
                                                v-model="FSC"
                                                :rules="[
                                                    v =>
                                                        !!v || 'FSC is required'
                                                ]"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-btn
                                                color="primary"
                                                @click="validate()"
                                                class="float-right"
                                                >KAG Contract</v-btn
                                            >
                                            <v-btn
                                                color="primary"
                                                @click="openKagCostco()"
                                                class="float-left mr-5"
                                                >KAG Costco</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <showExcel
            v-if="$store.state.invoice.excel"
            :data="invoices"
            :Kms="Kms"
            :FSC="FSC"
            :invIds="invIds"
            :totals="totals"
            :StartDate="$store.state.getMsk('StartDate')"
            :EndDate="$store.state.getMsk('EndDate')"
        >
        </showExcel>

        <kagCostco
            v-if="$store.state.invoiceKms.kagCostco"
            :StartDate="$store.state.getMsk('StartDate')"
            :EndDate="$store.state.getMsk('EndDate')"
        ></kagCostco>
    </v-container>
</template>
<script>
import axios from 'axios';
import showExcel from './../Modals/Administration/Invoice/LoadExcel.vue';
import kagCostco from './../Modals/Administration/Invoice/KAGCostco.vue';
import * as XLSX from 'xlsx';
import { mask } from 'vue-the-mask';
export default {
    name: 'Yards',
    components: {
        showExcel,
        kagCostco
    },
    directives: { mask },
    data: function() {
        return {
            valid: true,
            Kms: null,
            totals: [],
            FSC: null,
            startDate: '',
            endDate: '',
            invoices: [],
            invIds: [],
            alertMsg: '',
            alert: false,
            searchInv: '',
            numberRule: [
                v =>
                    (!isNaN(parseFloat(v)) && v >= 0) ||
                    'Only numbers are allowed'
            ]
        };
    },

    computed: {
        formTitle() {
            return this.edited.id === 0 ? 'New Item' : 'Edit Item';
        }
    },

    watch: {
        dialog(val) {
            val || this.cancel();
        }
    },

    mounted() {},

    methods: {
        readExcel: async function(e) {
            console.log(e.target.files[0]);
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = e => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                this.jsonData = JSON.stringify(jsonData, null, 2);
            };

            reader.readAsArrayBuffer(file);
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.getTransactionKagInvoices();
            }
        },
        openKagCostco: function() {
            this.$store.state.invoiceKms.kagCostco = true;
            console.log(
                'openKagCostco',
                this.$store.state.invoiceKms.kagCostco
            );
        },
        getTransactionKagInvoices: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                data: this.jsonData,
                FSC: this.FSC,
                Kms: this.Kms,
                Export: 0
            };
            axios
                .post('invoice/kms/show', parms)
                .then(async response => {
                    this.invoices = response.data.details;
                    this.totals = response.data.total;
                    this.invIds = response.data.invIds;
                    console.log(this.invoices);
                    this.$store.state.invoice.excel = true;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        searchInvoice: async function() {
            this.$store.state.isLoading = true;

            if (this.searchInv == '') {
                this.$store.state.isLoading = false;
                this.alert = true;
                this.alertMsg = 'Invoice number needed';
            } else {
                try {
                    let response = await axios.get(
                        'invoice/kms/check/' + this.searchInv,
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    );
                    console.log(response.data);
                    this.$store.state.invoiceKms.search = this.searchInv;
                    console.log(this.$store.state.invoiceKms.search);
                    this.$store.state.isLoading = false;
                    this.$router.push('/administration/invoice-search');
                } catch (error) {
                    if (error.response.status === 404) {
                        this.alert = true;
                        this.alertMsg = 'Invoice not found';
                        this.searchInv = '';
                    }
                }
                this.$store.state.isLoading = false;
            }
        }
    }
};
</script>
